export const ROUTES = {
  LOGIN: 'LOGIN',
  REGISTRATION: 'REGISTRATION',
  VERIFICATION: 'VERIFICATION',
  HOME: 'HOME',
  INSPECTIONS: 'INSPECTIONS',
  INSPECTION: 'INSPECTION',
  USER: 'USER',
  SETTINGS: 'SETTINGS',
  TASKS: 'TASKS',
  NOT_FOUND: '404',
  COMPANIES: 'COMPANIES',
  COMPANY_EDIT: 'COMPANY_EDIT',
  COMPANY_CREATE: 'COMPANY_CREATE',

  //Настройки
  SETTINGS_CHECK_LISTS: 'SETTINGS_CHECK_LISTS',
  SETTINGS_DOCUMENTS: 'SETTINGS_DOCUMENTS',
  SETTINGS_PRINT_TEMPLATES: 'SETTINGS_PRINT_TEMPLATES',
  SETTINGS_PROFILE: 'SETTINGS_PROFILE',
}

export const CABINET_MAIN_PAGE = ROUTES.INSPECTIONS

export const DEFAULT_TITLE = 'МояПриемка'

export const goToClientCabinet = () => {
  window.location.href = `${window.location.origin}/lk/`
}